import moment from 'moment';
import { dateFormatZurich } from 'utils/datetime';

export const convertDate = (date: string): string => moment(date).format(dateFormatZurich);
